import React, { useEffect, useState } from "react";
import "./CardContentActionTile.css";
import { Grid, Box } from "@mui/material";
import { fonts, themes } from "../../themes/themes";
import { useAppSelector } from "../../../infra/hooks";
import { check_user_permission } from "../../configs/utils";

interface contentTileType {
  tile_value: string;
  onEdit?: any;
  onDelete?: any;
}
const CardContentActionTile: React.FC<contentTileType> = ({
  tile_value,
  onDelete,
  onEdit,
}) => {
  const auth_permissions = useAppSelector((state:any) => state.authPermissionSlice?.authPermission);
  return (
    <Grid container className="action-tileContainer_skills">
      <Grid
        item
        style={{
          flexGrow: 1,
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.tileKey_grey,
          textTransform: "capitalize",
        }}
      >
        {tile_value}
      </Grid>
      <Grid
        item
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "right",
        }}
      >
       {
        check_user_permission(auth_permissions,true,"edit")?
        <Grid container spacing={2}>
          <Grid item>
            <Box onClick={onEdit}>
              <i className="las la-pencil-alt editIcon_skills" />
            </Box>
          </Grid>
          <Grid item>
            <Box onClick={onDelete}>
              <i className="las la-trash-alt deleteIcon_skills" />
            </Box>
          </Grid>
        </Grid>
        :<></>
       }
      </Grid>
    </Grid>
  );
};

export default CardContentActionTile;
